import { lazy } from 'react';
import { retry } from '../../config/utils';

const CaptureDocument = lazy(() => retry(()=> import(/* webpackChunkName: "capture-document" */ "./index")));

export default CaptureDocument;